module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('i', [_vm._v("Braeden Paul Would Like to Thank")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("My father, Robby Paul, and grandfather Bobby Paul for introducing me to this big part of my life called bluegrass music.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mother, Michelle Hammock, for constantly seeing my potential and making sure others saw it as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("David, Diana, Zack, Adam, Lindsay, Jared and all of my family for their love and support.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John Lawless and Terry Herd of "), _c('i', [_vm._v("Bluegrass Today")]), _vm._v(" for giving me a chance to exercise my writing muscle on a weekly basis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Southwest Bluegrass Club for their tireless promotion of bluegrass music and their support of my endeavors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All of the individuals who gave their time and resources for the book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jeff Campbell for being a great collaborator and guiding me through the book writing process.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_c('i', [_vm._v("Jeff Campbell Would Like to Thank")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("My wife for her love, encouragement and support.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alan Tompkins and the Bluegrass Heritage Foundation for treating us like family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alan Munde for being an encouraging mentor and writing the foreword for this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Central Texas Bluegrass Association for its enthusiastic support.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rick Gardner and Liz Patton for their wonderful photos.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All of the talented musicians who gave their time to be interviewed for this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My coauthor, Braeden Paul, for agreeing to take on the challenge of writing a book, one more time!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313efe6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 78
// module chunks = 0